import { isProduction, isStg } from '../app-config/environment'
import { STG_ENV } from '../app-config/stg-env'

const PDF_REST_API_URL = {
  dev: 'https://pdfservice.dev.surecolabs.com',
  prod: 'https://pdfservice.docday.com',
  stg: STG_ENV.pdfServiceUrl,
}

export const getApiUrl = () => {
  if (isStg()) {
    return PDF_REST_API_URL.stg
  }
  if (isProduction()) {
    return PDF_REST_API_URL.prod
  }
  return PDF_REST_API_URL.dev
}
